import React, { useEffect, useRef, useState } from "react";
import "./BroadbandSwitcher.css";

const TYPE_LABEL = { internet: "Internet", dvpl: "DVPL", railtel: "RailTel" };

/**
 * One "Internet" section for the customer's Internet, DVPL and RailTel accounts. Every
 * account shows as a chip tagged with its type; picking one shows that account's own card
 * (InternetPlanCard / RailtelPlanCard), so each still talks to its own provider's API.
 *
 * accounts: [{ type, key, username, status: "active"|"expired"|null, sub, onRemove? }]
 */
const BroadbandSwitcher = ({ accounts, activeType, activeKey, onPick, linkTypes, onLink }) => {
  const [menu, setMenu] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!menu) return undefined;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setMenu(false);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("touchstart", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("touchstart", close);
    };
  }, [menu]);

  return (
    <div className="bbs">
      <div className="bbs-head">
        <h2 className="plan-title title-internet bbs-title">INTERNET</h2>
        {linkTypes.length > 0 && (
          <div className="bbs-link" ref={ref}>
            <button type="button" className="bbs-link__btn" onClick={() => setMenu((m) => !m)} aria-expanded={menu}>
              + Link account
            </button>
            {menu && (
              <div className="bbs-link__menu" role="menu">
                {linkTypes.map((t) => (
                  <button key={t} type="button" role="menuitem" onClick={() => { setMenu(false); onLink(t); }}>
                    {TYPE_LABEL[t]} account
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Only when there is more than one account to choose from */}
      {accounts.length > 1 && (
        <div className="bbs-chips" role="tablist" aria-label="Internet accounts">
          {accounts.map((a) => {
            const on = a.type === activeType && String(a.key) === String(activeKey);
            return (
              <div key={`${a.type}-${a.key}`} className={`bbs-chip ${on ? "is-on" : ""}`}>
                <button type="button" role="tab" aria-selected={on} className="bbs-chip__main" onClick={() => onPick(a)}>
                  <span className="bbs-chip__top">
                    <span className={`bbs-type bbs-type--${a.type}`}>{TYPE_LABEL[a.type]}</span>
                    {a.status && <span className={`bbs-status bbs-status--${a.status}`}>{a.status === "active" ? "Active" : "Expired"}</span>}
                  </span>
                  <span className="bbs-chip__user">{a.username}</span>
                  {a.sub ? <span className="bbs-chip__sub">{a.sub}</span> : null}
                </button>
                {a.onRemove && (
                  <button type="button" className="bbs-chip__x" title="Remove this account" onClick={a.onRemove}>✕</button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BroadbandSwitcher;
